var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "solutionguide" },
    [
      _c("Breadcrumb"),
      _vm._v(" "),
      _c("StepApplication"),
      _vm._v(" "),
      _c("StepComponent"),
      _vm._v(" "),
      _c("StepProperty"),
      _vm._v(" "),
      _c("StepDecor"),
      _vm._v(" "),
      _c("StepResult"),
      _vm._v(" "),
      _vm.isDebugMode
        ? _c(
            "div",
            [
              _c("hr"),
              _vm._v(
                "\n        Anwendung: " +
                  _vm._s(
                    _vm.$store.state.application &&
                      _vm.$store.state.application.name
                  )
              ),
              _c("br"),
              _vm._v(
                "\n        Komponente: " +
                  _vm._s(
                    _vm.$store.state.component &&
                      _vm.$store.state.component.name
                  )
              ),
              _c("br"),
              _vm._v(
                "\n        Produkt: " +
                  _vm._s(
                    _vm.$store.state.result && _vm.$store.state.result.title
                  )
              ),
              _c("br"),
              _vm._v(
                "\n        selectedDecor: " +
                  _vm._s(_vm.$store.getters.selectedDecor)
              ),
              _c("br"),
              _vm._v(" "),
              _vm.$store.state.component
                ? [
                    _vm._v(
                      "\n            Produkte für Komponente:\n            "
                    ),
                    _c(
                      "table",
                      _vm._l(
                        _vm.$store.state.component.productIds,
                        function (productId) {
                          return _c("tr", [
                            _c("th", [
                              !_vm.$store.getters.isProductAvailable(
                                _vm.$store.getters.getProduct(productId)
                              )
                                ? _c("s", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$store.getters.getProduct(productId)
                                          .title
                                      )
                                    ),
                                  ])
                                : _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$store.getters.getProduct(productId)
                                          .title
                                      )
                                    ),
                                  ]),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.$store.getters.getProduct(
                                      productId
                                    ).configApi,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("Config")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$store.getters.getProduct(productId)
                                      .decors.length
                                  ) +
                                  " Decors\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.$store.getters.getProduct(productId)
                                    .propertyIds,
                                  function (id) {
                                    return _c("li", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$store.getters.getProperty(id)
                                              .name
                                          ) +
                                          "\n                        "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.productScore(
                                      _vm.$store.getters.getProduct(productId)
                                        .propertyIds
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(
                      "\n            Bestes Produkt: " +
                        _vm._s(_vm.bestesProdukt()) +
                        "\n        "
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v("\n        Alle Produkte\n        "),
              _c(
                "table",
                _vm._l(_vm.$store.state.segment.productMap, function (product) {
                  return _c("tr", [
                    _c("th", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: product.detail_link,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(product.title))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: product.configApi, target: "_blank" },
                        },
                        [_vm._v("Config")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(product.decors.length) + " Dekore"),
                    ]),
                  ])
                }),
                0
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }